import { ApiHelper } from './apiHelper';

export class EmailUpdateApi {
    async UpdateEmail(data, token, successCallback, failureCallback, signal) {
        const dataUrl = '/api/EmailUpdateManager/updateEmail';

        await new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            data,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
}
